import React, { useContext } from 'react';

import { LeafStateContext } from 'context/state/leaf';
import { CameraStateProvider } from 'context/state/camera';

import { CameraTile, CameraTileType } from 'components/camera/CameraTile';
import { CameraControlDeckType } from 'components/camera/CameraControlDeck';

import { AppDeviceLeaf } from 'types/common/leaf';

interface CameraTileProps extends React.HTMLAttributes<HTMLDivElement> {
  cameraTileType?: CameraTileType;
  controlDeckType?: CameraControlDeckType;
  isSoundEnabled?: boolean;
  isFocusedView?: boolean;
}

export const CameraTileContainer = ({
  cameraTileType = 'normal',
  controlDeckType,
  isSoundEnabled = false,
  isFocusedView = false,
  className,
}: CameraTileProps) => {
  const { leaf } = useContext(LeafStateContext);

  return (
    <CameraStateProvider
      initState={{
        fullscreenEnabled: false,
        microphoneEnabled: false,
        pipEnabled: false,
        recording: { recordingEnabled: false, startTime: null, recorder: null },
        soundEnabled: isSoundEnabled,
      }}
    >
      <CameraTile
        key={`${leaf.id}-ct-${cameraTileType}`}
        id={`${leaf.id}-ct-${cameraTileType}`}
        className={className}
        leaf={leaf as AppDeviceLeaf}
        cameraTileType={cameraTileType}
        controlDeckType={controlDeckType}
        isFocusedView={isFocusedView}
      />
    </CameraStateProvider>
  );
};
